// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35vRA","colMin":"styles_colMin__24Sjy"};